import React from "react";
const FOOTER_HOME_URL = "https://www.ufginsurance.com/home";
const FOOTER_COPYRIGHT_NAME = "United Fire & Casualty Company";
const COLUMN_CLASS = "col-sm-3";
const TARGET_BLANK = "_blank";
const REL_NOREFERRER = "noreferrer";

const FOOTER_LOGO = {
  src: `${window.env.REACT_APP_PUBLICSITE_BASEURL}/images/default-source/default-album/ufg_-_bw_reversed.tmb-thumb160.png?Culture=en&sfvrsn=86c1c155_1`,
  alt: "UFG logo",
  title: "UFG logo",
};

const SOCIAL_LINKS = [
  {
    href: "https://www.facebook.com/UFGInsurance/",
    ariaLabel: "Follow UFG on Facebook",
    iconClass: "icon-facebook",
    image: {
      src: `${window.env.REACT_APP_PUBLICSITE_BASEURL}/images/default-source/default-album/ico-facebook.png?sfvrsn=84f655_8`,
      alt: "Facebook",
      title: "Facebook",
    },
  },
  {
    href: "https://www.linkedin.com/company/ufginsurance",
    ariaLabel: "Follow UFG on LinkedIn",
    iconClass: "icon-linkedin",
    image: {
      src: `${window.env.REACT_APP_PUBLICSITE_BASEURL}/images/default-source/default-album/ico-linkedin.png?sfvrsn=e687f655_6`,
      alt: "LinkedIn",
      title: "LinkedIn",
    },
  },
];

const FOOTER_SECTIONS = [
  {
    title: "Navigate",
    links: [
      { label: "Express bill pay", href: `${window.env.REACT_APP_PUBLICSITE_BASEURL}/pay-my-bill` },
      {
        label: "Report a claim",
        href: `${window.env.REACT_APP_PUBLICSITE_BASEURL}/insurance/services/claims-capabilities/report-a-claim`,
      },
      { label: "Find an agent", href: `${window.env.REACT_APP_PUBLICSITE_BASEURL}/find-an-agent` },

    ],
  },
  {
    title: "Connect",
    links: [
      { label: "UFG Insurance", href: `${window.env.REACT_APP_PUBLICSITE_BASEURL}` },
      {
        label: "Contact us",
        href: `${window.env.REACT_APP_PUBLICSITE_BASEURL}/contact-us`,
        listItemClassName: "nav-path-selected",
      },
    ],
  },
  {
    title: "Legal and compliance",
    links: [
      {
        label: "Accessibility statement",
        href: `${window.env.REACT_APP_PUBLICSITE_BASEURL}/about-ufg/privacy-other-terms-of-use/accessibility-statement`,
      },
      {
        label: "Do not sell my personal data",
        href: "https://forms.raleyapps.com/form/render/4b003aef-5336-48df-84f9-cf7934d05824/4x9ssbb6fm",
        external: true,
      },
      {
        label: "Ethics hotline",
        href: "https://ir.ufginsurance.com/governance/ethics-hotline/default.aspx",
        external: true,
      },
      {
        label: "Marketing opt-out",
        href: "https://forms.raleyapps.com/form/render/4b003aef-5336-48df-84f9-cf7934d05824/4x9ssbb6fm",
        external: true,
      },
      {
        label: "Privacy and other terms of use",
        href: `${window.env.REACT_APP_PUBLICSITE_BASEURL}/about-ufg/privacy-other-terms-of-use`,
      },
      {
        label: "Third party code of business conduct",
        href: "https://s205.q4cdn.com/556706552/files/doc_governance/2025/Aug/04/third-party-code-of-business-conduct-e47823.pdf",
        external: true,
      },
    ],
  },
];

const renderFooterLink = (link) => {
  if (link.href) {
    const targetProps = link.external
      ? { target: TARGET_BLANK, rel: REL_NOREFERRER }
      : {};

    return (
      <a href={link.href} className={link.className} {...targetProps}>
        {link.label}
      </a>
    );
  }

  return (
    <a className={link.className} role={link.role} tabIndex={link.tabIndex}>
      {link.label}
    </a>
  );
};

const Footer = () => {
  return (
    <footer id="footer">
      <div className="container">
        <div className="row">
          <div className={COLUMN_CLASS}>
            <div className="footer-logo">
              <br />
              <a href={FOOTER_HOME_URL}>
                <img
                  src={FOOTER_LOGO.src}
                  alt={FOOTER_LOGO.alt}
                  title={FOOTER_LOGO.title}
                />
              </a>
            </div>

            <div>
              <br />
              <p>
                {SOCIAL_LINKS.map((socialLink) => (
                  <a
                    key={socialLink.href}
                    href={socialLink.href}
                    target={TARGET_BLANK}
                    rel={REL_NOREFERRER}
                    aria-label={socialLink.ariaLabel}
                  >
                    <span className={socialLink.iconClass} aria-hidden="true">
                      <img
                        src={socialLink.image.src}
                        alt={socialLink.image.alt}
                        title={socialLink.image.title}
                      />
                    </span>
                  </a>
                ))}
              </p>
            </div>
          </div>

          {FOOTER_SECTIONS.map((section) => (
            <div key={section.title} className={COLUMN_CLASS}>
              <h3>{section.title}</h3>
              <ul>
                {section.links.map((link) => (
                  <li key={link.label} className={link.listItemClassName}>
                    {renderFooterLink(link)}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <p className="copy">
        &copy; {new Date().getFullYear()} {FOOTER_COPYRIGHT_NAME}. All rights
        reserved.
      </p>
    </footer>
  );
};

export default Footer;
